import { keyframes, styled } from 'styled-components';

import { color } from '@creditornot/cb-ingredients/design-tokens';

const pulse = keyframes`
  50% {
    opacity: .5;
  }
`;

const Skeleton = styled.div<{ $width?: string; $height?: string; $margin?: string }>`
  width: ${props => props.$width ?? '100%'};
  height: ${props => props.$height ?? 'calc(100% - 2px - 2px)'};
  margin: ${props => props.$margin ?? '2px 0'};
  background-color: ${color.textDisabled};
  border-radius: 0.3rem;
  animation: 2s ${pulse} cubic-bezier(0.4, 0, 0.6, 1) infinite;
`;

export default Skeleton;
